import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as allocation from '../allocation'

export const RESOURCE = {
  payload: {
    canBeOptional: true,
    context: core.dms.models.Attribute.Id.Context.from({
      context: allocation.RESOURCE.payload.dimension.partialId,
      partialId: allocation.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Entity,
    }),
    description: 'Actual weekly hours for this allocation.',
    isOptional: true,
    name: 'Actual Weekly Hours',
    partialId: PartialId.Standard.create('actual_weekly_hours'),
    type: core.common.value.types.Intrinsic.Integer,
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
